export const determineOffSet = () => {
  if (window.innerWidth <= 800) {
    return 105;
  } else if (window.innerWidth <= 1200) {
    return 140;
  } else {
    return 150;
  }
};
